import React, { useState } from 'react';
import { ChevronLeft, ChevronRight, ZoomIn } from 'lucide-react';

const Portfolio = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);

  const projects = [
    {
      id: 1,
      image: 'https://customer-assets.emergentagent.com/job_basement-legal/artifacts/8kxa597i_21678.jpg',
      title: 'Staircase Staining - Before',
      category: 'Flooring & Staining',
      isBeforeAfter: true,
    },
    {
      id: 2,
      image: 'https://customer-assets.emergentagent.com/job_basement-legal/artifacts/5ik68lu8_21682.jpg',
      title: 'Staircase Staining - After',
      category: 'Flooring & Staining',
      isBeforeAfter: true,
    },
    {
      id: 3,
      image: 'https://customer-assets.emergentagent.com/job_basement-legal/artifacts/en3qs2vh_21710.jpg',
      title: 'Luxury Kitchen with Custom Cabinetry',
      category: 'Kitchen',
    },
    {
      id: 4,
      image: 'https://customer-assets.emergentagent.com/job_basement-legal/artifacts/dxx6ljna_21712.jpg',
      title: 'Modern Kitchen Renovation',
      category: 'Kitchen',
    },
    {
      id: 5,
      image: 'https://customer-assets.emergentagent.com/job_basement-legal/artifacts/jlmnk906_21694.jpg',
      title: 'Contemporary Kitchen Design',
      category: 'Kitchen',
    },
    {
      id: 6,
      image: 'https://customer-assets.emergentagent.com/job_basement-legal/artifacts/jcwbqi6p_21684.jpg',
      title: 'Luxury Bathroom with Marble & Gold Fixtures',
      category: 'Bathroom',
    },
    {
      id: 7,
      image: 'https://customer-assets.emergentagent.com/job_basement-legal/artifacts/wvcxk4go_21698.jpg',
      title: 'Modern Glass Shower Installation',
      category: 'Bathroom',
    },
    {
      id: 8,
      image: 'https://customer-assets.emergentagent.com/job_basement-legal/artifacts/jndpjeq4_21696.jpg',
      title: 'Custom TV Wall with Fireplace & Marble',
      category: 'TV Wall & Fireplace',
    },
    {
      id: 9,
      image: 'https://customer-assets.emergentagent.com/job_basement-legal/artifacts/x4dckml1_21704.jpg',
      title: 'Custom Bar with LED Lighting',
      category: 'Entertainment Area',
    },
    {
      id: 10,
      image: 'https://customer-assets.emergentagent.com/job_basement-legal/artifacts/oh4m5jzn_21686.jpg',
      title: 'Complete Interior with Custom Flooring',
      category: 'Full Renovation',
    },
  ];

  const nextImage = () => {
    setCurrentIndex((prev) => (prev + 1) % projects.length);
  };

  const prevImage = () => {
    setCurrentIndex((prev) => (prev - 1 + projects.length) % projects.length);
  };

  const openLightbox = (index) => {
    setCurrentIndex(index);
    setSelectedImage(projects[index]);
  };

  const closeLightbox = () => {
    setSelectedImage(null);
  };

  return (
    <section id="portfolio" className="py-24 bg-gradient-to-b from-gray-50 to-white relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <div className="inline-flex items-center px-4 py-2 bg-blue-50 rounded-full border border-blue-100 mb-6">
            <span className="text-[#0070C0] font-semibold text-sm">OUR PORTFOLIO</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold mb-6 text-gray-900">
            Transformations That Speak for Themselves
          </h2>
          <p className="text-xl text-gray-600 leading-relaxed">
            Browse through our recent projects and see the quality craftsmanship that makes N-Teek
            Home Renovations stand out.
          </p>
        </div>

        {/* Featured Before/After Section */}
        <div className="mb-16 bg-gradient-to-br from-blue-50 to-white rounded-3xl p-8 border border-blue-100">
          <div className="text-center mb-8">
            <h3 className="text-2xl md:text-3xl font-bold text-gray-900 mb-3">
              Featured Project: Staircase Transformation
            </h3>
            <p className="text-gray-600">See the dramatic difference in this staircase staining project</p>
          </div>
          <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto">
            <div className="relative group">
              <div className="absolute top-4 left-4 z-10">
                <span className="bg-red-500 text-white px-4 py-2 rounded-lg font-bold text-sm shadow-lg">
                  BEFORE
                </span>
              </div>
              <div className="relative">
                <img
                  src="https://customer-assets.emergentagent.com/job_basement-legal/artifacts/8kxa597i_21678.jpg"
                  alt="Staircase Before Staining"
                  className="w-full h-96 object-cover rounded-2xl shadow-xl group-hover:shadow-2xl transition-shadow"
                />
                {/* Watermark */}
                <div className="absolute bottom-4 right-4 pointer-events-none">
                  <div className="text-white/50 font-bold text-xl select-none">
                    N-TEEK HOME RENOVATIONS
                  </div>
                </div>
              </div>
            </div>
            <div className="relative group">
              <div className="absolute top-4 left-4 z-10">
                <span className="bg-green-500 text-white px-4 py-2 rounded-lg font-bold text-sm shadow-lg">
                  AFTER
                </span>
              </div>
              <div className="relative">
                <img
                  src="https://customer-assets.emergentagent.com/job_basement-legal/artifacts/5ik68lu8_21682.jpg"
                  alt="Staircase After Staining"
                  className="w-full h-96 object-cover rounded-2xl shadow-xl group-hover:shadow-2xl transition-shadow"
                />
                {/* Watermark */}
                <div className="absolute bottom-4 right-4 pointer-events-none">
                  <div className="text-white/50 font-bold text-xl select-none">
                    N-TEEK HOME RENOVATIONS
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Portfolio Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {projects.map((project, index) => (
            <div
              key={project.id}
              className="group relative rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-500 cursor-pointer"
              onClick={() => openLightbox(index)}
            >
              {/* Image */}
              <div className="aspect-[4/3] overflow-hidden bg-gray-200 relative">
                <img
                  src={project.image}
                  alt={project.title}
                  className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-700"
                  loading="lazy"
                />
                {/* Watermark */}
                <div className="absolute bottom-4 right-4 pointer-events-none">
                  <div className="text-white/40 font-bold text-lg select-none">
                    N-TEEK HOME RENOVATIONS
                  </div>
                </div>
              </div>

              {/* Overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                <div className="absolute bottom-0 left-0 right-0 p-6 transform translate-y-4 group-hover:translate-y-0 transition-transform duration-500">
                  <span className="inline-block px-3 py-1 bg-[#0070C0] text-white text-xs font-semibold rounded-full mb-3">
                    {project.category}
                  </span>
                  <h3 className="text-white text-xl font-bold mb-2">{project.title}</h3>
                  <div className="flex items-center text-white text-sm">
                    <ZoomIn className="w-4 h-4 mr-2" />
                    Click to view
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Lightbox Modal */}
      {selectedImage && (
        <div
          className="fixed inset-0 bg-black/95 z-50 flex items-center justify-center p-4"
          onClick={closeLightbox}
        >
          <button
            onClick={closeLightbox}
            className="absolute top-4 right-4 text-white text-4xl hover:text-gray-300 transition-colors z-10"
          >
            ×
          </button>

          <button
            onClick={(e) => {
              e.stopPropagation();
              prevImage();
            }}
            className="absolute left-4 text-white hover:text-gray-300 transition-colors z-10"
          >
            <ChevronLeft className="w-12 h-12" />
          </button>

          <button
            onClick={(e) => {
              e.stopPropagation();
              nextImage();
            }}
            className="absolute right-4 text-white hover:text-gray-300 transition-colors z-10"
          >
            <ChevronRight className="w-12 h-12" />
          </button>

          <div
            className="max-w-6xl w-full"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="relative">
              <img
                src={projects[currentIndex].image}
                alt={projects[currentIndex].title}
                className="w-full h-auto max-h-[85vh] object-contain rounded-lg"
              />
              {/* Watermark for lightbox */}
              <div className="absolute bottom-6 right-6 pointer-events-none">
                <div className="text-white/60 font-bold text-2xl select-none">
                  N-TEEK HOME RENOVATIONS
                </div>
              </div>
            </div>
            <div className="text-center mt-6">
              <h3 className="text-white text-2xl font-bold mb-2">
                {projects[currentIndex].title}
              </h3>
              <span className="inline-block px-4 py-2 bg-[#0070C0] text-white text-sm font-semibold rounded-full">
                {projects[currentIndex].category}
              </span>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default Portfolio;
